import Vuex from 'vuex'
import Vue from '../../../plugins/vue'
import axios from '../../../plugins/axios'

Vue.use(Vuex);

export default new Vuex.Store({
	state() {
		return {
			ads: {},
			fetchedAds: {},
			brandStories: [],
			brandStoriesStatus: false,
			jobs: []
		}
	},
	mutations: {
		ads(state, { key, value }) {
			state.ads[key] = value;
		},
		fetchedAds(state, { key, value }) {
			state.fetchedAds[key] = value;
		},
		brandStoriesStatus(state, val) {
			state.brandStoriesStatus = val;
		},
		brandStories(state, data) {
			state.brandStories = data;
		},
		jobs(state, data) {
			state.jobs = data;
		}
	},
	actions: {
		async fetchMultipleAds({ commit, state }, items) {
			const result = await axios.postForm('/actions/site/ad/ads', {
				items
			});

			if(result?.data) {
				for(const [ key, value ] of Object.entries(result.data)) {
					commit('ads', { key, value });
					commit('fetchedAds', { key, value: 'loaded' });
				}
			}

			// Add items without any result to the state
			for(const key in items) {
				if(!state.fetchedAds[key]) {
					commit('ads', { key, value: [] });
					commit('fetchedAds', { key, value: 'loaded' });
				}
			}
		},
		async fetchAds({ commit }, { position, transformation }) {
			const key = `ad-${position}-${transformation}`;
			const result = await axios.postForm('/actions/site/ad', {
				position: position,
				transformation: transformation
			});

			commit('ads', { key: key, value: result.data });
			commit('fetchedAds', { key: key, value: 'loaded' });
		},
		async getRandomAd({ state, commit, dispatch }, { position, transformation }) {
			const key = `ad-${position}-${transformation}`;

			if (!state.fetchedAds[key]) {
				commit('fetchedAds', { key: key, value: 'loading' });
				await dispatch('fetchAds', { position, transformation });
			}

			await new Promise((resolve, reject) => {
				(function waitForAds() {
					if (state.fetchedAds[key] === 'loaded') {
						return resolve();
					}
					setTimeout(waitForAds, 30);
				})();
			});

			const xl = window.matchMedia("(min-width: 1280px)")?.matches;

			if (xl) {
				const ads = state.ads[key].filter(x => {
					if (x.positionLargeScreens == 'defaultPlacement') {
						return x.position == position;
					}

					return x.positionLargeScreens == position;
				});
				return ads[Math.floor(Math.random() * ads.length)] ?? null;
			} else {
				const ads = state.ads[key].filter(x => x.position == position);
				return ads[Math.floor(Math.random() * ads.length)] ?? null;
			}
		},
		async adView({  }, data) {
			const result = await axios.postForm('/actions/site/ad/click', data);

			return result?.data;
		},
		async adClick({  }, data) {
			const result = await axios.postForm('/actions/site/ad/click', data);

			return result?.data;
		},
		async getBrandStories({ state, commit }, data) {

			if (!state.brandStoriesStatus) {
				commit('brandStoriesStatus', 'loading');
				const result = await axios.postForm('/actions/site/brand-stories', data);
				commit('brandStories', result?.data);
				commit('brandStoriesStatus', 'loaded');
			}

			await new Promise((resolve, reject) => {
				(function waitForBrandStories(){
					if (state.brandStoriesStatus === 'loaded') {
						return resolve();
					}
					setTimeout(waitForBrandStories, 30);
				})();
			});
		},
		async getJobs({ commit }, data) {
			const result = await axios.postForm('/actions/site/jobs', data);

			if (result) {
				commit('jobs', result.data);
			}
		}
	}
});
